import { Col, View } from '@amzn/stencil-react-components/layout';
import { MessageBanner } from '@amzn/stencil-react-components/message-banner';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { deleteNotification } from '../../actions/notificationActions';

const ToastNotificationBody = ({ timeout, id, message, type }) => {
  const dispatch = useDispatch();

  const containerTransition = keyframes`
    from {
        transform: translateY(-80%);
    }
    to {
        transform: translateY(0);
    }
  `;
  const AnimatedContainer = styled(Col)({
    animation: `${containerTransition} 0.3s ease`,
  });

  useEffect(
    () => {
      const interval = setInterval(() => {
        dispatch(deleteNotification(id));
      }, timeout);
      return () => {
        clearInterval(interval);
      };
    },
    [timeout],
  );

  return (
    <AnimatedContainer>
      <View key={id}>
        <MessageBanner isDismissible onDismissed={() => removeNotification(id)} type={type}>
          {message}
        </MessageBanner>
      </View>
    </AnimatedContainer>
  );
};

export default ToastNotificationBody;
